import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Joi from 'joi';
import { IChangeEmail } from 'src/app/interfaces/patient.interfaces';

@Component({
    selector: 'email-input-modal',
    templateUrl: './email-input.component.html',
    styleUrls: ['./email-input.component.scss'],
    standalone: false,
})
export class EmailInputModalComponent {
    public oldEmail: string;
    public message: string | undefined;
    public newEmail: string = '';

    public constructor(
        public DialogRef: MatDialogRef<EmailInputModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IChangeEmail,
    ) {
        this.oldEmail = data.email;
        this.message = data.message;
    }
    public isEmailValid(): boolean {
        const trimmedEmail = this.newEmail.trim();
        if (trimmedEmail.length === 0) return false;
        const emailSchema = Joi.string().email({ tlds: { allow: false } });
        return !emailSchema.validate(trimmedEmail).error;
    }
    public saveEmail() {
        if (!this.isEmailValid) return;
        this.DialogRef.close({ newEmail: this.newEmail });
    }
}
